import { useEffect,useState } from 'react';
import { getGeneralLabInformation } from '../../api/api';
import { errorNotify } from '../../services/toast.notification';
import { useAppDispatch, useAppSelector } from '../../redux/store/storehooks';
import { UpdateGeneralLabInfo } from '../../redux/reducers/GeneralLabInfoSlice';
import SystemInfo from './SystemInfo';
import Material from './Material';
import Storage from './Storage';
import QC from './QC';
import Financial from './Financial';
import Statistics from './Statistics';
import Confirmation from './Confirmation';

export interface InputProps {
    url: any
  }
const GeneralLabInfo = ({url}:InputProps) =>{
    const [activeTab, setActiveTab] = useState(1);
    const myStore = useAppSelector((state:any) => state)
    const dispatch = useAppDispatch();
    const [isLoading,setIsLoading] = useState(true);

  const handleTabClick = (id:any) => {
    setActiveTab(id);
  };
  
  useEffect(()=>
  {
      loadInfo(url);
     
  },[]);

  const loadInfo = (url:string) => {
    getGeneralLabInformation(url)
        .then((result:any) => {
            let jsonResult = JSON.parse(result.data.json);
            dispatch(UpdateGeneralLabInfo({ MyBriefFinancial:jsonResult.MyBriefFinancial,MyBriefLabConfirmation:jsonResult.MyBriefLabConfirmation,
                MyBriefLabStatistics:jsonResult.MyBriefLabStatistics,MyBriefInstrumentTemperature:jsonResult.MyBriefInstrumentTemperature,
                MyBriefSystem:jsonResult.MyBriefSystem,MyBriefStorage:jsonResult.MyBriefStorage,
                MyBriefQC:jsonResult.MyBriefQC}))
            setIsLoading(false);
        })
        .catch((error) => {
          console.log(error);
          errorNotify(error.response.data.errorMessage,undefined,5000)
        })
}

  return (
    <div>
        <ul className="inner-tabs">
        <li className={activeTab === 1 ? 'financialRepTabActive' : 'financialRepTab'} onClick={() => handleTabClick(1) }> گزارشات مالی</li>
            <li className={activeTab === 2 ? 'statisticalRepTabActive' : 'statisticalRepTab'} onClick={() => handleTabClick(2) }>گزارشات آماری</li>
            <li className={activeTab === 3 ? 'digitalSignatureTabActive' : 'digitalSignatureTab'} onClick={() => handleTabClick(3) }>امضا دیجیتال</li>
            <li className={activeTab === 4 ? 'systemInfoTabActive' : 'systemInfoTab'} onClick={() => handleTabClick(4) }>اطلاعات سیستم</li>
            <li className={activeTab === 5 ? 'materialTabActive' : 'materialTab'} onClick={() => handleTabClick(5) }>تجهیزات</li>
            <li className={activeTab === 6 ? 'storageTabActive' : 'storageTab'} onClick={() => handleTabClick(6) }>انبارداری</li>
            <li className={activeTab === 7 ? 'qcTabActive' : 'qcTab'} onClick={() => handleTabClick(7) }>کنترل کیفی</li>
            {/* <li className={activeTab === 8 ? 'samplingTabActive' : 'samplingTab'} onClick={() => handleTabClick(8) }>نمونه‌گیری درب منزل</li> */}
        </ul>

        <div className="inner-tabs_content">
            { 
              activeTab === 1 && <div className="tab_panel">
                <Financial data={myStore.generalLabInfo.MyBriefFinancial} isloading={isLoading} />
              </div> 
            }
            { activeTab === 2 && <div className="tab_panel"><Statistics data={myStore.generalLabInfo.MyBriefLabStatistics} isloading={isLoading} />  </div> }
            { activeTab === 3 && <div className="tab_panel">  <Confirmation  data={myStore.generalLabInfo.MyBriefLabConfirmation} isloading={isLoading}/> </div> }
            { activeTab === 4 && <div className="tab_panel"><SystemInfo data={myStore.generalLabInfo.MyBriefSystem} isloading={isLoading} /></div> }
            { 
               activeTab === 5 && 
              <div className="tab_panel">
                 <Material data={myStore.generalLabInfo.MyBriefInstrumentTemperature} isloading={isLoading} />
              </div>
           }
            { 
               activeTab === 6 && 
              <div className="tab_panel">
                 <Storage data={myStore.generalLabInfo.MyBriefStorage} isloading={isLoading}/>
              </div>
           }
            { activeTab === 7 && 
            <div className="tab_panel">  
              <QC data={myStore.generalLabInfo.MyBriefQC} isloading={isLoading} />
            </div> }

        </div>
    </div>
  );
};

export default GeneralLabInfo;